"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TYPE_Y = exports.TYPE_X = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // Note: this file and all others under custom-scrollbars are pulled out of the package
// react-scrollbars-custom, because we require a very custom modification to allow
// the vertical scrollbar to work with our "upside-down" message list component in the
// bsweb app (i.e., for that component, the thumb drags and track clicks need to be handled
// backwards from usual). To allow this, there are modifications in index.js, Track.js, and 
// Thumb.js.  All changes are marked with the comment
//
// zipwhip modification from react-scrollbars-custom
//
// to allow possible re-absorption of changes/fixes that might occur in the source library.
// For the same reason, additional customization such as auto-hiding behavior that does not
// have to be added to the original react-scrollbars-custom code itself is handled a level up
// in the ScrollArea component.


var TYPE_X = exports.TYPE_X = 1;
var TYPE_Y = exports.TYPE_Y = 2;

var Track = function (_React$Component) {
  _inherits(Track, _React$Component);

  function Track(props) {
    _classCallCheck(this, Track);

    var _this = _possibleConstructorReturn(this, (Track.__proto__ || Object.getPrototypeOf(Track)).call(this, props));

    _this.onClickHandler = function (ev) {
      if (ev.target !== _this.element || !_this.props.onClick) {
        return true;
      }

      var rect = _this.element.getBoundingClientRect(); // zipwhip modification from react-scrollbars-custom


      var offset = 0;

      if (_this.props.type === TYPE_X) {
        offset = ev.clientX - rect.left;
      } else {
        if (_this.props.flip) {
          offset = rect.bottom - ev.clientY;
        } else {
          offset = ev.clientY - rect.top;
        }
      }

      _this.props.onClick(ev, {
        axis: _this.props.type,
        offset: offset
      });
    };

    return _this;
  }

  _createClass(Track, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          renderer = _props.renderer,
          type = _props.type,
          elementRef = _props.elementRef,
          onClick = _props.onClick,
          flip = _props.flip,
          props = _objectWithoutProperties(_props, ["className", "renderer", "type", "elementRef", "onClick", "flip"]);

      props.className = "track " + (type === TYPE_X ? "trackX" : "trackY") + (className ? " " + className : "");
      props.onClick = this.onClickHandler;
      return renderer ? renderer(props) : _react2.default.createElement("div", _extends({}, props, {
        ref: function ref(_ref) {
          typeof elementRef === "function" && elementRef(_ref);
          _this2.element = _ref;
        }
      }));
    }
  }]);

  return Track;
}(_react2.default.Component);

Track.displayName = "Scrollbar Track";
Track.propTypes = {
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,
  flip: _propTypes2.default.bool,
  // zipwhip modification from react-scrollbars-custom
  type: _propTypes2.default.oneOf([TYPE_X, TYPE_Y]).isRequired,
  elementRef: _propTypes2.default.func,
  renderer: _propTypes2.default.func
};
exports.default = Track;